import(/* webpackMode: "eager" */ "/home/u650493134/domains/kelolify.com/hbuilds/source/repository/node_modules/next/dist/client/app-dir/link.js");
